const CreativeAgencyDesignShowcase = () => {
  return (
    <>
      <div className="section-space bgc-white">
        <div className="section-space--sm-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="heading-4 text-center clr-text mb-0">
                  We Craft Beautiful & Unique Design
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6 col-lg-4 col-xxl-3">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-1.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-2.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-3.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-4.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-5">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-5.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-3">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-6.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xxl-4">
              <div className="showcase-card">
                <img
                  src="assets/img/creative-agency/showcase-7.png"
                  alt="image"
                  className="img-fluid w-100 h-100"
                />
                <div className="showcase-card__content padding-6 rounded-4 bgc-white">
                  <a
                    href="#"
                    className="link d-inline-flex text-center padding-y-1 padding-x-4 rounded-pill bgc-danger clr-white :clr-white fs-14 margin-bottom-4"
                  >
                    App Design
                  </a>
                  <h6 className="heading-6 mb-0">
                    <a
                      href="#"
                      className="link d-block font-weight-semibold clr-text :clr-primary"
                    >
                      Bento 3D Illustration
                    </a>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyDesignShowcase;
